<template>
  <div
    class="rounded-extra-small flex-rounded bg-surface-container group relative flex grow cursor-pointer items-center gap-3 overflow-hidden px-4 py-2"
    @click="navigateToAssessment"
  >
    <div class="flex grow flex-row items-center">
      <div
        class="bg-primary-container text-on-primary-container mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
      >
        <BaseIcon size="24">{{ assessment.feedbackTopic.icon }}</BaseIcon>
      </div>
      <div class="flex flex-col">
        <h3 class="text-title-medium">
          {{ assessment.title ?? assessment.feedbackTopic.title }}
        </h3>
      </div>
    </div>

    <div class="flex w-40 shrink-0 flex-col justify-end">
      <BaseLinearProgressIndictor :percentage="percentage" />
      <span class="text-body-medium text-on-surface-variant mt-0.5">
        {{ assessment.completedTandemCount }}/{{ assessment.totalTandemCount }}
        {{ $t('common.finished') }}</span
      >
    </div>
    <div class="flex w-32 shrink-0 flex-col">
      <BaseMemberAvatars
        class="bg-surface-container"
        :members="assessment.coachees"
        size="32"
        :displayLimit="5"
      />
      <span class="text-body-medium text-on-surface-variant mt-0.5 whitespace-nowrap"
        >{{ assessment.coachees.length }}
        {{ $t('common.coachees', assessment.coachees.length) }}</span
      >
    </div>
    <div v-if="assessment.peers.length > 0" class="flex w-32 shrink-0 flex-col">
      <BaseMemberAvatars
        class="bg-surface-container"
        :members="assessment.peers"
        size="32"
        :displayLimit="5"
      />
      <span class="text-body-medium text-on-surface-variant mt-0.5 whitespace-nowrap"
        >{{ assessment.peers.length }} {{ $t('common.peers', assessment.peers.length) }}</span
      >
    </div>
    <div v-else class="w-32 shrink-0"></div>
    <BaseIcon class="text-on-surface-variant shrink-0">chevron_right</BaseIcon>
    <BaseStateLayer />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'
  import BaseMemberAvatars from '@/core/components/base/avatar/BaseMemberAvatars.vue'
  import BaseLinearProgressIndictor from '@/core/components/base/linear-progress-indicator/BaseLinearProgressIndictor.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import type { AssessmentPreview } from '../components/use-assessments'

  interface Props {
    assessment: AssessmentPreview
  }

  const { assessment } = defineProps<Props>()
  const router = useRouter()

  const navigateToAssessment = () => {
    router.push({ name: 'assessment', params: { surveyTemplateId: assessment.id } })
  }

  const percentage = computed(() => {
    const finished = assessment.completedTandemCount
    const total = assessment.totalTandemCount

    if (total === 0) {
      return 0
    }

    return Math.round((finished / total) * 100)
  })
</script>
